module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"体重":"体重","スコア":"スコア"},"en":{"体重":"Weight","スコア":"Score"}}')
  delete Component.options._Ctor
}
